module.exports = __webpack_public_path__ + "media/images/sheffield_ctru-497ec9b86a5314fe8d6ca998fc186170.png";